import logo from './logo.svg';
import Login from './Components/ClassComponents/Login'
import Registration from './Components/ClassComponents/Registration'
import { Route, Routes } from 'react-router-dom';
import Navigation from './Components/ClassComponents/Navigation';
function App() {
  return (
    <>
       <Navigation /> 
    </>
  );
}

export default App;
